// extracted by mini-css-extract-plugin
module.exports = {"mailOrderSection":"MailOrderSection_mailOrderSection__XLMOI","button":"MailOrderSection_button__qSzc1"};